(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-text"] && !Shopify.designMode) return;
  try {
    class CollapsibleTextComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.content = this.querySelector('.collapsible-text-content');
      this.button = this.querySelector('.collapsible-text-button-wrapper');
      this.buttonText = this.button.querySelector('button');
      
      if (!this.button || !this.content) return;

      this.showText = this.buttonText.getAttribute('data-show-text');
      this.hideText = this.buttonText.getAttribute('data-hide-text');
      this.isExpanded = false;

      this.checkIfButtonNeeded();
      this.setupEventListeners();
    }

    checkIfButtonNeeded() {
      const contentHeight = this.content.scrollHeight;
      const previewHeight = this.content.getAttribute('data-content-height');
      
      if (contentHeight <= previewHeight) {
        this.button.style.display = 'none';
        this.content.classList.remove('collapsed');
      }
    }

    setupEventListeners() {
      this.button.addEventListener('click', () => {
        this.toggleContent();
      });
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.content.classList.remove('collapsed');
        this.content.classList.add('expanded');
        this.buttonText.textContent = this.hideText;
        this.button.setAttribute('aria-expanded', 'true');
      } else {
        this.content.classList.remove('expanded');
        this.content.classList.add('collapsed');
        this.buttonText.textContent = this.showText;
        this.button.setAttribute('aria-expanded', 'false');
      }
    }
  }
  if (!customElements.get('collapsible-text-component')) customElements.define('collapsible-text-component', CollapsibleTextComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        copyButton: this.querySelector('.button-copy'),
        nativeShareButton: this.querySelector('.button-native-share')
      };

      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }

      if (this.elements.nativeShareButton && navigator.share) {
        this.elements.nativeShareButton.classList.remove('hidden');
        this.elements.nativeShareButton.setAttribute('aria-hidden', false);
        this.elements.nativeShareButton.addEventListener('click', this.triggerNativeShare.bind(this));
      }
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.showCopiedFeedback();
      });
    }

    async triggerNativeShare(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      try {
        await navigator.share({
          title: this.dataset.shareTitle,
          url: this.dataset.shareUrl
        });
      } catch (error) {
        if (error?.name !== 'AbortError') {
          this.copyToClipboard();
        }
      }
    }

    showCopiedFeedback() {
      const copyLabel = this.elements.copyButton?.querySelector('.button-copy__label');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.setAttribute('aria-hidden', false);
      }
      if (copyLabel) copyLabel.textContent = 'Copied';

      setTimeout(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.setAttribute('aria-hidden', true);
        }
        if (copyLabel) copyLabel.textContent = 'Copy link';
      }, 1500);
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
